export function isEmbedContext(): boolean {
	return typeof window !== 'undefined' && window.parent !== window;
}

// In-memory token for embed context. Third-party iframes can't set cookies,
// so we hold the token in memory after receiving it via postMessage.
let embedToken: string | null = null;

export function setEmbedToken(token: string) {
	embedToken = token;
}

export function getEmbedToken(): string | null {
	return embedToken;
}

export function clearEmbedToken() {
	embedToken = null;
}
